import { createAction } from '@reduxjs/toolkit';

const setDebtAccount = createAction('account/setDebtAccount', function prepare(accountId, checked) {
  return {
    payload: {
      accountId,
      checked
    }
  };
});

const amountChange = createAction('account/amountChange', function prepare(accountId, type, value) {
  return {
    payload: {
      accountId,
      type,
      value
    }
  };
});

export { setDebtAccount, amountChange };
